import React from 'react'
import useScreenSize from '@hooks/useScreenSize'

export interface Props {
  logo?: React.ReactNode
  children: React.ReactNode
  left: React.ReactNode
  bottom?: React.ReactNode
}

export default function Layout({logo, left, bottom, children}: Props) {
  const screenSize = useScreenSize()
  const isSmall = ['mobile', 'sm', 'md'].includes(screenSize)

  return (
    <div className="bg-gray-100 text-black dark:bg-zinc-900 dark:text-white min-h-screen flex flex-col gap-4 lg:gap-9 lg:py-9">
      <section>{logo}</section>
      {isSmall ? (
        <>
          <section className="w-full mb-[-16px]">{left}</section>
          <section className="w-full">{children}</section>
        </>
      ) : (
        <div className="flex justify-center">
          <div className="rounded-xl bg-white flex shadow-xl overflow-auto">
            <section className="overflow-hidden w-[690px] h-[650px]">{left}</section>
            <section className="w-[539px] h-[650px] flex flex-col py-4 dark:bg-zinc-800">
              <div className="overflow-y-auto flex-1">{children}</div>
            </section>
          </div>
        </div>
      )}
      <section>{bottom}</section>
    </div>
  )
}
